import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
	CapacityTypeLabels,
	ClientsPerCapacityLabels,
} from '@core/util/capacity';
import { ICON } from '@core/util/icon';
import { getMortgageLenderName } from '@core/util/mortgage';
import { CapacityPerClientType } from '@models/matter';
import { Lender, LenderWithAssociations } from '@models/lender';
import {
	DropdownOption,
	DropdownOptions,
	DropdownResult,
} from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';

@Component({
	selector: 'app-lender-percentage-of-interest',
	templateUrl: './lender-percentage-of-interest.component.html',
	standalone: false,
})
export class LenderPercentageOfInterestComponent {
	@Input() set lender(lender: LenderWithAssociations) {
		this.lenderName = getMortgageLenderName(lender);
		this._lender = lender;
		this.percentageOfInterest = this._lender.percentageOfInterest;
		this.percentageOfInterestType = this._lender.percentageOfInterestType;
		this.percentageOfInterestTypeLabel = this.percentageOfInterestOptions.find(
			(option) => option.value === this._lender.percentageOfInterestType,
		)?.name;
	}

	@Output() onLenderPercentageOfInterestDetailsUpdated = new EventEmitter<{
		percentage: string;
		type: CapacityPerClientType;
	}>();

	public _lender: LenderWithAssociations;

	public lenderName = '';
	public percentageOfInterestTypeLabel: string;

	public percentageOfInterestType: CapacityPerClientType;
	public percentageOfInterest: string;

	public percentageOfInterestOptions: DropdownOptions<CapacityPerClientType> =
		Object.values(CapacityPerClientType).map((capacity) => {
			return {
				name: ClientsPerCapacityLabels[capacity],
				value: capacity,
			};
		});

	public ICON = ICON;

	setPercentageOfInterestType(
		$event: DropdownResult<DropdownOption<CapacityPerClientType>>,
	) {
		this.percentageOfInterestType = $event.result.value;
		this.percentageOfInterestTypeLabel = $event.result.name;
		this.updatePercentageOfInterestDetails();
	}

	updatePercentageOfInterestDetails() {
		this.onLenderPercentageOfInterestDetailsUpdated.emit({
			percentage: this.percentageOfInterest,
			type: this.percentageOfInterestType,
		});
	}
}
